import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Input, Button, InputGroupAddon } from 'reactstrap';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import Ionicon from 'react-ionicons';

import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';
import { downlodFile } from '../../utils/utils';
import ModalService from '../../services/ModalService';
import { messages } from '../../constants/constant.message';
import ActivityReportService from '../../services/ActivityReportService';


class SetActivityTarget extends Component {

  constructor(props) {
    super(props);
    this.state = {
      targetActivity: [],
      isMonthPickerOpen: false,
      years: this.getYears(),
      months: this.getMonths(),
      selectedYear: new Date().getFullYear(),
      selectedMonth: this.getSelectedMonth(),
      search: null,
      isLoading: false
    };
  }

  componentDidMount() {
    let { isMonthPickerOpen } = this.state;
    this.getTargetActivity(this.state.selectedMonth, this.state.selectedYear);

    const that = this;
    window.addEventListener('click', function handleClick(e) {
      if ((document.getElementById('monthYearCalendarDiv') && document.getElementById('monthYearCalendarDiv').contains(e.target)) || (document.getElementById('monthYearCalendarInput') && document.getElementById('monthYearCalendarInput').contains(e.target))) {
        // Clicked in box
        isMonthPickerOpen = true;
        that.setState({ isMonthPickerOpen });

      } else {
        isMonthPickerOpen = false;
        that.setState({ isMonthPickerOpen });
        // Clicked outside the box
      }
    });
  }

  openMonthPicker = () => {
    let { isMonthPickerOpen } = this.state;
    isMonthPickerOpen = !isMonthPickerOpen;
    this.setState({ isMonthPickerOpen });
  }

  getYears = () => {
    const arr = [];
    for (let i = new Date().getFullYear(); i >= 1970; i--) {
      arr.push(i);
    }

    return arr;
  }

  getMonths = () => {
    return [{
      label: 'Jan',
      value: 1
    },
    {
      label: 'Feb',
      value: 2
    },
    {
      label: 'Mar',
      value: 3
    },
    {
      label: 'Apr',
      value: 4
    },
    {
      label: 'May',
      value: 5
    },
    {
      label: 'Jun',
      value: 6
    },
    {
      label: 'Jul',
      value: 7
    },
    {
      label: 'Aug',
      value: 8
    },
    {
      label: 'Sep',
      value: 9
    },
    {
      label: 'Oct',
      value: 10
    },
    {
      label: 'Nov',
      value: 11
    },
    {
      label: 'Dec',
      value: 12
    }
    ];
  }

  getSelectedMonth = () => {
    return _.find(this.getMonths(), { value: new Date().getMonth() + 1 });
  }

  handleYearChange = (e) => {
    let { selectedYear } = this.state;
    selectedYear = e.target.value;
    this.setState({ selectedYear });
    this.getTargetActivity(this.state.selectedMonth, selectedYear, this.state.search);
  }

  handleMonthChange = (obj) => {
    let { selectedMonth, isMonthPickerOpen } = this.state;
    selectedMonth = obj;
    isMonthPickerOpen = !isMonthPickerOpen;
    this.setState({ selectedMonth, isMonthPickerOpen });
    this.getTargetActivity(selectedMonth, this.state.selectedYear, this.state.search);
  }

  openCloseSideBar = () => {
    let { sidebarOpen } = this.state;
    sidebarOpen = !sidebarOpen;
    this.setState({ sidebarOpen });
  }

  getTargetActivity = (selectedMonth, selectedYear, search = null, downloadReport = false) => {
    let reqObj = {
      m: selectedMonth.value,
      y: selectedYear,
      q: search,
      download_report: downloadReport
    }
    this.setState({ isLoading: true });
    ActivityReportService.getTotalActivityTarget(reqObj)
      .then(res => {
        this.setState({ isLoading: false });
        if (downloadReport) {
          const { file } = res.data.data;
          downlodFile(file);
          return;
        }
        const { data } = res.data;
        this.setState({ targetActivity: data.activity });
      })
      .catch(e => {
        console.error('e', e);
      });
  }

  handleInputChange = (i, e) => {
    const { targetActivity } = this.state;
    if (e.target.value === null || e.target.value === '' || parseInt(e.target.value) < 0) {
      targetActivity[i][e.target.name] = '0';
    } else {
      const value = `${parseInt(e.target.value)}`;
      targetActivity[i][e.target.name] = value;
    }
    this.setState({ targetActivity });
  }

  handleFieldLeave = (i, e) => {
    // const { targetActivity } = this.state;
    // if (e.target.value === null || e.target.value === '' || parseInt(e.target.value) < 0) {
    //   targetActivity[i][e.target.name] = '0';
    // } else {
    //   const value = `${parseInt(e.target.value)}`;
    //   targetActivity[i][e.target.name] = value;
    // }
    // this.setState({ targetActivity });

    // this.updateSalesReport(targetActivity[i], false);
  }

  updateSalesReport = (targetActivity, showPopup = true) => {
    if (!targetActivity) {
      targetActivity = this.state.targetActivity;
    } else {
      targetActivity = [targetActivity];
    }
    const reqObj = {
      data: targetActivity
    };

    this.setState({ isLoading: true });

    ActivityReportService.updateActivityTarget(reqObj)
      .then(data => {
        this.setState({ isLoading: false });
        if (showPopup) {
          ModalService.openAlert('Congratulations!', (data.data || {}).message || '', 'success');
        }
      })
      .catch(e => {
        ModalService.openAlert('Sorry!', messages.COMMON.ERROR_MESSAGE, 'error');
      });
  }

  searchTargetSales = (e) => {
    this.setState({ search: e.target.value });
    this.getTargetActivity(this.state.selectedMonth, this.state.selectedYear, e.target.value);
  }

  downloadTargetSales = (e) => {
    this.getTargetActivity(this.state.selectedMonth, this.state.selectedYear, this.state.search, true);
  }

  openSalesReportPage = () => {
    this.props.history.push('/activity-report');
  }

  render() {
    const { isMonthPickerOpen, years, months, selectedMonth, selectedYear, 
      // sidebarOpen, 
      isLoading } = this.state;
    const prepareRow = (this.state.targetActivity || []).map((ts, i) =>
      <tr>
        <td className="text-align-left title-case">
          <div>{ts.business_name}</div>
          <div>{ts.region_name} ({ts.area_name})</div>
        </td>
        <td>
          <Input type="number" className="table-input ml-auto mr-auto" name="heal_the_wheel" value={ts.heal_the_wheel} onChange={this.handleInputChange.bind(this, i)}
            onBlur={this.handleFieldLeave.bind(this, i)} />
        </td>
        <td>
          <Input type="number" className="table-input ml-auto mr-auto" name="driver_training" value={ts.driver_training} onChange={this.handleInputChange.bind(this, i)}
            onBlur={this.handleFieldLeave.bind(this, i)}
          />
        </td>
        <td
        ><Input type="number" className="table-input ml-auto mr-auto" name="scrap_analysis" value={ts.scrap_analysis} onChange={this.handleInputChange.bind(this, i)}
          onBlur={this.handleFieldLeave.bind(this, i)}
          />
        </td>
      </tr>
    );
    return (
      <div id="target-sales">
        {isLoading && <CustomSpinner />}
        <Row>
          <Col>
            <span className="prev-page-link cursor-pointer" onClick={this.openSalesReportPage}>Activity Report</span>
            <span>
              <Ionicon icon="ios-arrow-forward" fontSize="34px" color="#fdbb1f" />
            </span>
            <span className="current-page">
              Set Activity Target
            </span>
          </Col>
        </Row>

        <Row className="margin-top-10">
          <Col xl="3" md="3" sm="3" xs="3">
            <div id="monthYearCalendarInput" className="d-flex-row vehical-sku-id-search">
              <Input
                className="form-control"
                type="text"
                name="sap_id"
                value={selectedMonth && `${selectedMonth.label} ${selectedYear}`}
                onClick={this.openMonthPicker}
                // readOnly
                style={{ background: 'white' }}
                placeholder="Select Month" />
              <InputGroupAddon onClick={this.openMonthPicker} addonType="append" className="serach-icon" style={{ marginTop: '0px' }}>
                <div className="input-group-text" style={{ paddingRight: '5px', marginTop: '-1px' }}>
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon>
            </div>
          </Col>
        </Row>

        {isMonthPickerOpen &&

          <Row id="monthYearCalendarDiv" style={{ position: 'absolute', zIndex: '100' }}>
            <Col xl="4" md="4" sm="4" xs="4">
              <Card style={{ width: '97%' }}>
                <CardBody>
                  <Row>
                    <Col>
                      <select className="form-control" name="selectYear"
                        onChange={(e) => this.handleYearChange(e)} value={selectedYear}>
                        {
                          (years || []).map((year) => (
                            <option key={year}>{year}</option>
                          ))
                        }
                      </select>
                    </Col>
                  </Row>

                  <Row className="c-top-10">
                    {
                      (months || []).map((month) => (
                        <Col xl="4" md="4" sm="3" xs="3" key={month.value}>
                          <div>
                            <Button className="btn-month" color="default" onClick={(e) => this.handleMonthChange(month)}>{month.label}</Button>
                          </div>
                        </Col>
                      ))
                    }

                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        }
        <Row className="margin-top-10">
          <Col sm="8">
            <Row className="margin-top-10 text-align-right">
              <Col sm="6">
                <Input
                  type="text"
                  placeholder="Search using FM name or location"
                  value={this.state.search}
                  onChange={this.searchTargetSales}
                />
                <img src="images/search.svg" className="report-search" alt='report-search' />
              </Col>
              <Col sm="6" className="text-align-right">
                <img src="images/download.svg" className="download-report-icon margin-left-10" alt='download' />
                <span className="download-report cursor-pointer" onClick={this.downloadTargetSales}>{' '} Download Report</span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="margin-top-10 text-align-right">
          <Col sm="8">
            <Card>
              <CardBody>
                <table className="width-100">
                  <tr>
                    <th className="master-header text-left">
                      <div>FM Name [Region (Area)]</div>
                    </th>
                    <th className="header">Heal The Wheel</th>
                    <th className="header">Driver Training / Digital Training</th>
                    <th className="header">Scrap Analysis</th>
                  </tr>
                  {prepareRow}
                </table>
                <Button
                  className="mb-1 mr-1 btn-pill action-button margin-top-10 save-button"
                  onClick={() => this.updateSalesReport(false)}>
                  Save
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* <Row className="margin-top-10">
          <Col sm="6">

          </Col>
        </Row> */}
      </div>
    );
  }
}



export default SetActivityTarget;